import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearAll, clearResetBot, onGetLetterEval, setErrorMessageUser, setEvalDetails, setGeneralLetterDetails, setLoadingUser, showAttachmentFunc, showEvaluationDetailsFunc, showLetterEvaluationFormFunc } from '../../../config/redux/slice/appSlice'
import { getRequest, postRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'
import { digitalLetterDatatable } from '../../../helpers/dataTables'
import GeneralWrapper from '../../layout/GeneralWrapper'
import { DataTableWrapper, EvaluationInfoCard } from '../../components'
import LetterEvaluationModal from './LetterEvaluationModal'
import LetterHistoryDetails from './LetterHistoryDetails'
import AttachmentView from './AttachmentView'

export default function LetterHistory() {
const dispatch = useDispatch()
const [notapStaff, setNotapStaff] = useState({});
const { token, userData } = useSelector((state) => state.authData);

const {
  unSeenSuccessMsg,
  isRefreshed,
  digitalLetterManagement: { generalLetterDetails,  showLetterEvaluationForm, showAttachmentModal },
  evaluationManagement: { showEvaluationDetails, newData, evaluationsData}
} = useSelector((state) => state.app);

useEffect(()=>{
    dispatch(clearAll({}))
    if (isRefreshed) getSingleLetter();
    
    const shouldShow = generalLetterDetails?.NOTAP_STAFF_USER === userData?.email
    digitalLetterDatatable(evaluationsData, setDetails, shouldShow, userData?.email, generalLetterDetails?.LETTER_STATUS)
    
    getLetterHistory();
  }, [isRefreshed])

  const getSingleLetter = async () =>{
      const res = await getRequest(
        token,
        `${appApi.getSingleLetter(generalLetterDetails?.DIGITAL_LETTER_ID)}`,
        {},
        dispatch,
        "",
        "",
        ""
      )
      if(res != undefined && res.status < 400){
        dispatch(setGeneralLetterDetails({details: (res.data.data), modal: false}))
        // dispatch(setCertificateDetails({details: res.data.data, modal: false}))
      }
    }

    const getLetterHistory = async () =>{
      dispatch(clearAll({}))

      await getRequest(token, `${appApi.getLetterHistory(generalLetterDetails?.DIGITAL_LETTER_ID)}`, {}, dispatch, setLoadingUser, onGetLetterEval, setErrorMessageUser);
    };

    const setDetails = (details, type) => {
      dispatch(setEvalDetails({ details }))
      
      if(type === 'letter-details'){
        dispatch(showEvaluationDetailsFunc({modal: true}))
      }
    };

    const getNotapStaff = async () => {
      dispatch(clearAll({}))

      const res = await getRequest(token, `${appApi.getStaff}`, {}, dispatch, setLoadingUser, "", setErrorMessageUser);
      if(res && res.status < 400){
          let dataList = (res.data.data).filter((resItem)=> resItem.EMAIL === generalLetterDetails?.NOTAP_STAFF_USER)
          if(dataList.length > 0){
            setNotapStaff(dataList[0])
          }
      }
    }

    useEffect(() => {
      if (newData) {
        let shouldShow = generalLetterDetails?.NOTAP_STAFF_USER === userData?.email
          digitalLetterDatatable(evaluationsData, setDetails, shouldShow, userData?.email, generalLetterDetails?.LETTER_STATUS)
          dispatch(clearResetBot());
      } 

      if (unSeenSuccessMsg==='Evaluation Added Successfully' || unSeenSuccessMsg==='Evaluation Saved Successfully') {
          getLetterHistory();
      }     
    }, [newData, unSeenSuccessMsg]);

    useEffect(() => {
      getNotapStaff();
    }, [])

    return (
      <GeneralWrapper pageTitle={'Digital Letter Management'}>
        {showLetterEvaluationForm && <LetterEvaluationModal/>}
        {showEvaluationDetails && <LetterHistoryDetails/>}
        {showAttachmentModal && <AttachmentView filePath={generalLetterDetails?.ATTACH_DOCUMENTS} />}
        {(generalLetterDetails?.NOTAP_STAFF_USER && generalLetterDetails?.NOTAP_STAFF_USER && generalLetterDetails?.NOTAP_STAFF_USER !== "N/A") && <EvaluationInfoCard nextStaff={notapStaff} />}
        
        <DataTableWrapper 
          tableID="digitalLetterTable" 
          tableName='Evaluation'
          tableButtons={<ActionButtons />}
        >
          <thead>
              <tr>
                <th width={'20px'} data-orderable="false"></th>
                <th width={'16%'}>Role</th>
                <th width={'24%'}>User</th>
                <th >Comment</th>
                <th width={'16%'}>Created At</th>
              </tr>
          </thead>
          <tbody>
          </tbody>
        </DataTableWrapper>
      </GeneralWrapper>
    );
}

function ActionButtons(){
  const dispatch = useDispatch();

  const { userData } = useSelector((state) => state.authData);
  const { digitalLetterManagement:{ generalLetterDetails } } = useSelector((state) => state.app);

  return(
    <div style={{ columnGap: '0.5rem' }} className='d-flex'>
      {(generalLetterDetails?.NOTAP_STAFF_USER === userData?.email) && (
        <button onClick={()=> dispatch(showLetterEvaluationFormFunc({modal:true}))} className='btn btn-sm btn-outline-primary'>
          <i style={{fontSize: '1rem'}} className="mdi mdi-plus-circle mr-1"></i>
          <span>Add Evaluation</span>
        </button>
      )}
   
      {generalLetterDetails?.ATTACH_DOCUMENTS && (
        <button onClick={()=>{dispatch(showAttachmentFunc({modal: true}))}} className='btn btn-sm btn-outline-primary'>
          <i style={{fontSize: '1rem'}} className="mdi mdi-folder-open mr-1"></i>
          View Attachment
        </button>
      )}
    </div>
  );
}
